/* 排行榜 */

import i18n from '@/i18n'

const RankIndex = () =>
  import(/* webpackChunkName: 'rank' */ '../page/rank/RankIndex.vue')
const RankUsers = () =>
  import(/* webpackChunkName: 'rank' */ '../page/rank/children/RankUsers.vue')
const RankQuestions = () =>
  import(/* webpackChunkName: 'rank' */ '../page/rank/children/RankQuestions.vue')
const RankFeeds = () =>
  import(/* webpackChunkName: 'rank' */ '../page/rank/children/RankFeeds.vue')
const RankNews = () =>
  import(/* webpackChunkName: 'rank' */ '../page/rank/children/RankNews.vue')
const RankFollowers = () =>
  import(/* webpackChunkName: 'rank' */ '../page/rank/lists/FansList.vue')
const RankBalances = () =>
  import(/* webpackChunkName: 'rank' */ '../page/rank/lists/BalanceList.vue')
const RankIncome = () =>
  import(/* webpackChunkName: 'rank' */ '../page/rank/lists/IncomeList.vue')
const RankQuestionExperts = () =>
  import(/* webpackChunkName: 'rank' */ '../page/rank/lists/ExpertList.vue')
const RankQuestionLikes = () =>
  import(/* webpackChunkName: 'rank' */ '../page/rank/lists/QuestionLikesList.vue')
const RankCheckinLikes = () =>
  import(/* webpackChunkName: 'rank' */ '../page/rank/lists/CheckinList.vue')
const RankQuestionList = () =>
  import(/* webpackChunkName: 'rank' */ '../page/rank/lists/RankQuestionList.vue')
const RankFeedList = () =>
  import(/* webpackChunkName: 'rank' */ '../page/rank/lists/RankFeedList.vue')
const RankNewsList = () =>
  import(/* webpackChunkName: 'rank' */ '../page/rank/lists/RankNewsList.vue')

export default [
  {
    path: '/rank',
    component: RankIndex,
    meta: { title: i18n.t('rank.name') },
    redirect: '/rank/users',
    children: [
      {
        path: 'users',
        component: RankUsers,
        meta: {
          keepAlive: true,
        },
      },
      {
        path: 'questions',
        component: RankQuestions,
        meta: {
          keepAlive: true,
        },
      },
      {
        path: 'feeds',
        component: RankFeeds,
        meta: {
          keepAlive: true,
        },
      },
      {
        path: 'news',
        component: RankNews,
        meta: {
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: '/rank/users/followers',
    component: RankFollowers,
  },
  {
    path: '/rank/users/balance',
    component: RankBalances,
  },
  {
    path: '/rank/users/income',
    component: RankIncome,
  },
  {
    path: '/rank/users/question-experts',
    component: RankQuestionExperts,
  },
  {
    path: '/rank/users/question-likes',
    component: RankQuestionLikes,
  },
  {
    path: '/rank/users/checkin',
    component: RankCheckinLikes,
  },
  {
    path: '/rank/q/:time',
    component: RankQuestionList,
  },
  {
    path: '/rank/f/:time',
    component: RankFeedList,
  },
  {
    path: '/rank/n/:time',
    component: RankNewsList,
  },
]
